import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import foodMarketHubIcon from "../../../assets/svg/food-market-hub-icon.svg";
import kraaveIcon from "../../../assets/svg/kraave.svg";
import singaporeAirlineIcon from "../../../assets/svg/singapore-airline-icon.svg";
import starbucksIcon from "../../../assets/svg/starbucks-icon.svg";
import whackedIcon from "../../../assets/svg/whacked-icon.svg";
import xperantiIcon from "../../../assets/svg/xperanti-icon.svg";

export const GridStyled = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  maxWidth: "1240px",
  padding: "80px 0px",
  margin: "auto",
  gap: "48px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    alignSelf: "stretch",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "0px",
    gap: "24px",
    background: "#FAFAFA",
  },
}));

export const LogoWrapper = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
}));

export const TestimonialTitle = styling(Typography)((props) => ({
  color: `rgba(0, 0, 0, 0.87)`,
  fontSize: "56px",
  fontWeight: 400,
  lineHeight: "67.2px",
  fontFamily: "Georgia",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "48px",
    lineHeight: "57.6px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "32px",
    lineHeight: "38.4px",
  },
}));

export const TestimonialSubTitle = styling(Typography)((props) => ({
  color: "#512ACC",
  fontSize: "24px",
  fontFamily: "Manrope",
  fontWeight: 500,
  lineHeight: "28.8px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.21px",
  },
}));

export const TestimonialText = styling(Typography)((props) => ({
  margin: "0px",
  fontWeight: 500,
  fontSize: "20px",
  lineHeight: "28px",
  fontFamily: "Inter",

  b: {
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

export const BoldText = styling("span")((props) => ({
  fontWeight: 700,
}));

export const StarbucksIcon = styling(starbucksIcon)((props) => ({}));

export const SingaporeAirline = styling(singaporeAirlineIcon)((props) => ({}));

export const KraaveIcon = styling(kraaveIcon)((props) => ({}));

export const FoodMarketHubIcon = styling(foodMarketHubIcon)((props) => ({}));

export const XperantiIcon = styling(xperantiIcon)((props) => ({}));

export const WhackedIcon = styling(whackedIcon)((props) => ({}));

export const CarouselContainer = styling(Grid)((props) => ({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const CardsWrapper = styling("div")((props) => ({
  display: "flex",
  transition: "transform 0.5s ease-in-out",
  gap: "24px",
  padding: "0 24px 10px 24px",
}));

export const NavigationButtons = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  gap: "16px",
  width: "100%",
  padding: "0 0 56px 0",
}));

export const StepButton = styling(Button)((props) => ({
  display: "flex",
  width: "48px",
  height: "48px",
  minWidth: "48px",
  padding: "10px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "24px",
  background: props?.disabled ? "#D4D0EE" : "#40249B",
  color: "#fff",
  boxShadow: "0px 1px 3px 1px rgba(0, 0, 0, 0.25)",
  cursor: props?.disabled ? "not-allowed" : "pointer",
  ":hover": {
    backgroundColor: props?.disabled ? "#D4D0EE" : "#40249B",
  },
}));
